import { css } from 'linaria';

export const buttonClass = css`
  background: var(--service-light);
  &:hover {
    background: var(--service-light);
  }
`;
